module.exports = __webpack_public_path__ + "media/images/visio/tutorial-1-94240999cda24880caccdf33693951cb.jpg";